import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import { MdArrowForwardIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function For() {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  const containerStyle = {
    position: 'relative',
    marginTop: '50px', // Adjust as needed
  };

  const captionStyle = {
    position: 'absolute',
    top: '30%',
    left: '35%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'left',  // Ensure that the text inside the caption is left-aligned
    color: 'White',
  };
  const captionStyle1 = {
    position: 'absolute',
    top: '30%',
    left: '38%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'left',  // Ensure that the text inside the caption is left-aligned
    color: 'White',
  };

  const imageStyle = {
    objectFit: 'cover',
    // filter: 'opacity(2) brightness(2)',
  };

  const circleStyle = {
    width: '19%',
    height: '32%',
    backgroundColor: '#FFE114',
    color:'black',
    // backgroundColor: isHovered ? '#F7F9FF' : '#FFE114',
    // color: isHovered ? 'black' : 'black',
    // transition: 'background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s',
    // transform: isHovered ? 'translateX(10px)' : 'translateX(0)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: '-70%',
    right: '-41%',
  };
  const circleStyle1 = {
    width: '20%',
    height: '32%',
    backgroundColor: '#FFE114',
    color:'black',
    // backgroundColor: isHovered ? '#F7F9FF' : '#FFE114',
    // color: isHovered ? 'black' : 'black',
    // transition: 'background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s',
    // transform: isHovered ? 'translateX(10px)' : 'translateX(0)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: '-70%',
    right: '-55%',
  };
  
  const iconStyle = {
    border: 'none',
    backgroundColor: '#FFE114',
    color:'black',
    // backgroundColor: isHovered ? '#F7F9FF' : '#FFE114',
    // color: isHovered ? 'black' : 'black',
    // transition: 'background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s',
    // transform: isHovered ? 'translateX(10px)' : 'translateX(0)',
  };

  return (
    <Container
      fluid
      style={{
        marginBottom: '10px',
        height: 'auto',
        marginTop: '10px',
      }}
    >
      <Row className="justify-content-center" >
        <Col xs={12} sm={12} md={6} lg={4} >
          <Container style={containerStyle} >
            <Image
              src={process.env.PUBLIC_URL + '/assets/images/Job.png'}
              className="d-block w-100 "
              alt=""
              rounded
              style={imageStyle}
            />
            <span style={captionStyle1} >
              <h3 className='animated-images captionTextStyleFor' >For Job Seekers</h3>
              <p className='captionTextStyleForP'>
                Discover your next role
              </p>
              <div style={circleStyle} 
               onClick={() => {
                window.location.href = '/CandidateForm';
              }}
              // onClick={() => {navigate("/CandidateForm");}}
                    >
                <span style={{ ...iconStyle, bottom: '0', right: '0' }}>
                  <MdArrowForwardIos 
                  onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}
                  
                  />
                </span>
              </div>
            </span>
          </Container>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4}>
          <Container style={containerStyle}>
            <Image
              src={process.env.PUBLIC_URL + '/assets/images/Employers.png'}
              className="d-block w-100 "
              alt=""
              rounded
              style={imageStyle}
            />
            <span style={captionStyle}>
              <h3  className='animated-images captionTextStyleFor'>For Employers</h3>
              <p className='captionTextStyleForP'>
                Find your next talent
              </p>
              <div style={circleStyle1}  
               onClick={() => {
                window.location.href = '/EmployerForm';
              }}
              // onClick={() => { navigate("/EmployerForm");}}
                  >
                <span style={{ ...iconStyle, bottom: '0', right: '0' }} >
                  <MdArrowForwardIos 
                  onMouseOver={handleMouseOver}
                  onMouseOut={handleMouseOut}
                 />
                </span>
              </div>
            </span>
          </Container>
        </Col>
      </Row>
    </Container>
  );
}

export default For;
